import { Component, ViewEncapsulation, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Util } from '../../shared/utils/util';
import { AuthenticationService } from './authentication.service';

@Component({
    selector: 'app-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AuthenticationComponent implements OnInit {

    @ViewChild('templateTermo', { static: false }) modalAceiteTermo: TemplateRef<any>;

    constructor(
        private modalService: NgbModal,
        private router: Router,
        public authService: AuthenticationService
    ) { }

    ngOnInit() {
        if (!this.authService.getToken()) {
            this.authService.authenticate()
                .subscribe(() => {
                    this.tryStatement();
                },
                    () => {
                        this.router.navigate(['unauthorized']);
                    });
        } else {
            this.tryStatement();
        }
    }

    /**
  * Método responsável por iniciar a coleta do termo de responsabilidade
  */
    private tryStatement() {
        this.exibirTermoResponsabilidade();
        // Aguarda o termo ser assinado com sucesso
        this.authService.statementSignedSucessfullyEvent.subscribe(() => {
            this.fecharTermoResponsabilidade();
            this.bypassedAuthentication();
        });
    }

    /**
   * Método responsável por mostrar a modal que exibe o termo de responsabilidade
   */
    private exibirTermoResponsabilidade() {
        this.authService.getIsStatementSigned().subscribe(statementSigned => {
            if (!statementSigned) {
                this.modalService.open(this.modalAceiteTermo, { size: 'lg', backdrop: 'static', keyboard: false, centered: true });
            } else {
                this.bypassedAuthentication();
            }
        });
    }

    /**
    * Método responsável por liberar o usuário após a autenticação
    */
    private bypassedAuthentication() {
        this.authService.emitFullAuthentication();
        this.authService.IdentityPermissionAction.subscribe(permissionActionList => {
            this.router.navigate([`${Util.getRouteByMenuModel(this.authService.getFirstPermissionToLogin(permissionActionList))}`]);
        });
    }

    /**
    * Método responsável por fechar a modal de termo de responsabilidade
    */
    public fecharTermoResponsabilidade() {
        this.modalService.dismissAll();
    }

}
